module.exports = __webpack_public_path__ + "img/tju-logo.7d253f8d.png";